/**
 * @brisa/ui · AuthCallbackLoading
 *
 * Loading curto (<2s) durante OAuth callback. NÃO é spinner genérico —
 * BrandLogo + texto + 3 dots animados + skeleton de 3 linhas pulsantes.
 */
import * as React from 'react';
import { BrandLogo } from './brand-logo';

export interface AuthCallbackLoadingProps {
  message: string;
}

export function AuthCallbackLoading({ message }: AuthCallbackLoadingProps) {
  return (
    <div className="brisa-callback-loading" role="status" aria-live="polite">
      <BrandLogo size="md" />
      <p className="brisa-callback-loading__message">
        {message}
        <span className="brisa-callback-loading__dots" aria-hidden="true">
          <span /> <span /> <span />
        </span>
      </p>
      <div className="brisa-callback-loading__skeleton" aria-hidden="true">
        <span /> <span /> <span />
      </div>
    </div>
  );
}
